import type {
  SwiftIdApplicationAjax,
  SwiftIdApplicationCreateRequest,
  SwiftIdApplicationCreateResultAjax,
  SwiftIdApplicationSubmitResultAjax,
} from './swift-id-application.backend-model';
import type {
  SwiftIdApplication,
  SwiftIdApplicationData,
} from './swift-id-application.model';

export function transformSwiftIdApplicationCreate(
  item: SwiftIdApplicationCreateResultAjax,
  application: SwiftIdApplicationData,
): SwiftIdApplication {
  return {
    id: item.id,
    uuid: item.uuid,
    data: application,
  };
}

export function transformSwiftIdApplicationGet(
  item: SwiftIdApplicationAjax,
): SwiftIdApplication {
  return {
    id: item.id,
    userId: item.userId,
    primaryGivenName: item.primaryGivenName,
    primarySurname: item.primarySurname,
    uuid: item.uuid,
    applicationStatus: item.status.replace(/([a-z])([A-Z])/g, '$1 $2'),
    applicationSubstatus: item.substatus?.replace(/([a-z])([A-Z])/g, '$1 $2'),
    backOfficeAccountNumber: item.backOfficeAccountNumber,
    createdDateTime: item.createdAt * 1000,
    updatedDateTime: item.updatedAt * 1000,
    advisorCode: item.advisorCode,
    brokerageCode: item.brokerageCode,
    branchCode: item.branchCode,
    data: {
      ...item.data,
      applicants: item.data.applicants.map(applicant => ({
        ...applicant,
        applicationRelationships: applicant.applicationRelationships?.map(
          relationship => relationship.replace(/([a-z])([A-Z])/g, '$1 $2'),
        ),
      })),
    },
  };
}

export function transformSwiftIdApplicationSubmit(
  item: SwiftIdApplicationSubmitResultAjax,
  application: SwiftIdApplication,
): SwiftIdApplication {
  return {
    id: application.id,
    uuid: item.uuid,
    data: {
      ...application.data,
    },
    applicationStatus: item.status,
  };
}

export function convertBooleanToString(
  object: Record<string, any>,
): Record<string, any> {
  const convertedObj: Record<string, any> = { ...object };

  for (const key in object) {
    if (typeof object[key] === 'boolean') {
      convertedObj[key] = object[key].toString();
    } else if (
      object[key] &&
      typeof object[key] === 'object' &&
      !Array.isArray(object[key])
    ) {
      convertedObj[key] = convertBooleanToString(object[key]);
    } else if (Array.isArray(object[key])) {
      convertedObj[key] = object[key].map((item: any) =>
        typeof item === 'object' && item !== null
          ? convertBooleanToString(item)
          : item,
      );
    }
  }

  return convertedObj;
}

export function convertBooleansToStrings(
  application: SwiftIdApplicationData,
): SwiftIdApplicationCreateRequest {
  return convertBooleanToString(application) as SwiftIdApplicationCreateRequest;
}
